import React from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import PageBanner from 'components/banners/PageBanner';

function PressReleaseDetailsTwo() {
  return (
    <div>
      <Helmet>
        <title>Press Releases - CAP60</title>
        <meta
          name="description"
          content="Press release is a tool made to announce something that is newsworthy in the most objective way possible. Read all press release for getting more information!."
        />
        <meta name="keywords" content="press release, cap60 press release" />
      </Helmet>
      <PageBanner title="Dallas selects CAP60 to provide data management services for their new CSBG entity" />
      <Container>
        <div className="py-5">
          <Row>
            <Col md={3}>
              <p>
                <span className="font-weight-bold">DATE:</span>{' '}
                <span>September 15, 2018</span>
              </p>
            </Col>
            <Col md={3}>
              <p>
                <span className="font-weight-bold mr-2">CATEGORY:</span>
                <Badge variant="dark">Press Releases</Badge>
              </p>
            </Col>
          </Row>
          <h6 className="mt-4 mb-3 font-weight-bold">
            LOS ANGELES, CA – JUNE 15, 2017
          </h6>

          <p>
            Following a competitive RFP process, CAP60 has been selected to
            provide data management and reporting services for the new Community
            Services Block Grant (CSBG) entity of Texas, Community Council of
            Greater Dallas (CCGD).
          </p>

          <p>
            CCGD currently serves more than 500,000 requests per year for an
            array of social services. Community Council is also the home of the
            Dallas Area Agency on Aging, which provides benefits counseling,
            home care, legal assistance, transportation, bills and caregiver
            assistance. Community Council is also the lead agency for a highly
            successful Community Youth Development Program to offer college
            readiness opportunities and develop leadership skills.
          </p>
          <p>
            The desired goal of the CAP60 and CCGD agreement is to provide the
            Council with the data necessary to make informed, strategic
            decisions regarding present and future services. This is in
            addition, to supporting the existing reporting requirements to other
            CCGD funding sources.
          </p>

          <p>
            Neil Israel, Director of CSBG Business Process Implementation, had
            this to say, “It’s easy to see why CAP60 is considered to have the
            best CSBG data management system. In a word? Thorough.”
          </p>
          <p>
            CAP60 Company President, Hamid Kohan, lauded the company’s recent
            success saying, “it’s a testament to our experience and know-how,
            that more and more state and regional affiliations are turning to us
            for their data management needs. It’s an honor to have been chosen
            to work with CCDG. This brings the number of Community Action
            Agencies in Texas that CAP60 services to thirteen.”
          </p>
          <h6>About CAP60:</h6>
          <p>
            CAP60 is a provider of comprehensive Agency and Program Management
            tools that are designed for use by Community Action Programs,
            Domestic Violence & Shelters, and other, as well as other Health and
            Human Services organizations. CAP60 provides services to Agencies in
            over 35 States nationwide, the U.S. Virgin Islands, and Canada.
            CAP60’s customized applications are designed to meet the data
            collection, tracking, and reporting needs of all aspects of an
            agency. For more information please visit www.cap60.com , email
            sales@cap60.com, or call <b>917-668-9174.</b>
          </p>
        </div>
      </Container>
    </div>
  );
}

export default PressReleaseDetailsTwo;
